import { ListSortDirection, Sort } from "../../models/api/sort";
import { LegalEntityVendorDTO, LegalEntityVendorSTO } from "../../models/legal-entity-vendors";
import { BaseApiService } from "../base/base-api.service";

export class LegalEntityVendorsApiService extends BaseApiService<LegalEntityVendorDTO, LegalEntityVendorSTO> {
  constructor() {
    super({
      servicePath: "/LegalEntityVendors",
      loadItemsPath: "/GetLegalEntityVendors",
      saveItemsPath: "/SaveLegalEntityVendors",
    });
    this.defaultSort = [
      {
        name: "name",
        direction: ListSortDirection.Ascending,
      } as Sort,
    ];
  }
}
